<template>
   <v-container fluid> 

       <v-skeleton-loader
        v-if="isLoading"
          type="article, actions"
        ></v-skeleton-loader>

        <v-row v-if="!isLoading && submissionInfo.submissions.length==0" style="height:50%">
            <v-col cols="12">
                <div style="width: 240px; color:#0000005e; text-align: center;" class="mx-auto">
                    <v-icon style="font-size:15em; color:#0000002e" >local_printshop</v-icon>
                    <span style="font-size:1.6em;width: 220px;">{{ $t('wkt.admin.common.assessments.no-results') }}</span>
                </div>
            </v-col>
        </v-row>
       <v-row v-if="!isLoading && submissionInfo.submissions.length>0" style="padding-bottom: 0px;">
       <v-col cols="3" class="pb-0">
            <v-btn icon color="primary" @click="showPrev" :disabled="currentPos<=0"><v-icon>arrow_back</v-icon></v-btn>
            {{ $t('wkt.admin.assessments.tab.answer.final-evaluation') }} {{currentPos+1}} / {{submissionInfo.submissions.length}}
            <v-btn icon color="primary" @click="showNext" :disabled="currentPos>=submissionInfo.submissions.length-1"><v-icon>arrow_forward</v-icon></v-btn>
        </v-col>
      <v-col cols="1" offset="8" style="padding-bottom: 0px;">
          <v-btn icon color="primary" @click="print"><v-icon>print</v-icon></v-btn>
      </v-col>
    </v-row>
    <v-row>
        <v-col cols="12"  class="pt-0">  
            <iframe ref="builder" style="min-width:100%; border:0;" src="form-viewer.html?protected=true"/>
        </v-col>
        </v-row>
    </v-container>
</template>

<script> 

export default {
  name: 'ResponseOverview', 
  components: { 
  },
  
  data() {
      return {
          currentPos: 0,
          submissionInfo: {submissions:[]}, 
          isLoading: false,
          currentSubmission: { id:0, updateDate:null}
      }
  },
   methods: {
    refresh(survey,submissionInfo) {
        this.isLoading = true;
        this.submissionInfo=submissionInfo;
        this.currentPos=0;
        let me = this;
        setTimeout (function () {me.showSubmission(me.currentPos);},300);
        
    },
    showNext() {
        if (this.currentPos<this.submissionInfo.submissions.length-1)
        {
            this.showSubmission(++this.currentPos);
        }
    },
    showPrev() {
        if (this.currentPos>0)
        {
            this.showSubmission(--this.currentPos);
        }
    },
    print() {
        this.$refs.builder.contentWindow.postMessage({'action':'print'});
    },
    showSubmission(pos) {
        
            this.isLoading = false;
            let me = this;
            
            this.$nextTick(() => {
                    me.currentSubmission=me.submissionInfo.submissions[pos];
                    
                    let sdata = {  
                        'type': 'ready',
                        'definition':me.submissionInfo.form.definition, 
                        'lastSubmission':me.currentSubmission.submissionData?me.currentSubmission.submissionData:'{}', 
                        'sessionInfo':'{}'
                    };
                    me.$refs.builder.contentWindow.postMessage(sdata);
                    me.$refs.builder.style.minHeight = (window.innerHeight * 0.9 -230)+'px';
 
                    
            });

    },
    formatDateTime (value) {
        return !value ? '' : new Date(value).toLocaleDateString() + ' ' + new Date(value).toLocaleTimeString();
    },
   }
};
</script>
